var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layoutName,{tag:"component",attrs:{"materials":_vm.materials},on:{"ads:entry":_vm.onAdsEntry,"ads:view":_vm.onAdsView,"ads:click":_vm.onAdsClick}})}
var staticRenderFns = []

export { render, staticRenderFns }